import { intervalToDuration } from 'date-fns'

export function formatTimeDifference(targetDate: Date): string {
    const duration = intervalToDuration({
        start: new Date(),
        end: targetDate,
    })

    // Pad the numbers if needed
    const hours = String(duration.hours ?? 0).padStart(2, '0')
    const minutes = String(duration.minutes ?? 0).padStart(2, '0')
    const seconds = String(duration.seconds ?? 0).padStart(2, '0')

    return `${hours}h ${minutes}m ${seconds}s`
}